import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pluralize'
})
export class PluralizePipe implements PipeTransform {
  /**
   * Склоняет слово в зависимости от числа
   * @param value - число (количество)
   * @param singular - форма для 1 (например, "товар")
   * @param dual - форма для 2-4 (например, "товара")
   * @param plural - форма для 5+ (например, "товаров")
   * @returns правильная форма слова
   */
  transform(
    value: number,
    singular: string,
    dual: string,
    plural: string
  ): string {
    if (value === null || value === undefined) return '';

    const n = Math.abs(value);
    const lastDigit = n % 10;
    const lastTwoDigits = n % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
      return plural;
    }

    if (lastDigit === 1) {
      return singular;
    }
    if (lastDigit >= 2 && lastDigit <= 4) {
      return dual;
    }
    return plural;
  }
}
